import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import constants from '../Constants';

const PolicyHolder = () => {
    return (
        <span>
            - <i>Policyholder</i>
        </span>
    );
}

/*
const AddButton = (props) => {
    const { sequence, onDriverClick } = props;
    console.log(constants);
    return (
        <button
            onClick={() => onDriverClick(sequence)}
            className="btn btn-primary">
            Add
        </button>
    );
}
*/

const Remove = (props) => {
    console.log(constants);
    const { sequence, onDriverClick } = props;
    return (
        <button
            onClick={() => onDriverClick(sequence)}
            className="btn btn-danger">
            <i className={constants.icons.remove} />
            {` Remove`}
        </button>
    );
}

const DriverItem = (props) => {
    const { name, isPolicyHolder } = props;
    const yearsOld = moment(props.dateOfBirth, "YYYYMMDD").fromNow().replace(/ years ago/g, '');
    console.log(yearsOld);
    return (
        <div className="summary-list-item">
            
            <div className="row">
                <div className="col-md-8 item-data">
                    {name} ({yearsOld}) {isPolicyHolder === true ? <PolicyHolder /> : null}
                </div>
                <div className="col-md-4">
                    {isPolicyHolder === true ? null : <Remove {...props} />}
                </div>
                
            </div>
        </div>
    )
}

export default DriverItem;

DriverItem.propTypes = {
    name: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.number.isRequired,
    isPolicyHolder: PropTypes.bool.isRequired,
    onDriverClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/Review/DriverItem.js